/***************************************************
 * PDP scripts
 ***************************************************/
/*
document.addEventListener("DOMContentLoaded", () => {
  const videoSlide = document.querySelector('video.Image--lazyLoaded');
  videoSlide.style.opacity = '1';
});
*/
/*easyZoom*/
(function (root, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define(['jquery'], function ($) {
      factory($);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    module.exports = root.EasyZoom = factory(require('jquery'));
  } else {
    root.EasyZoom = factory(root.jQuery);
  }
})(this, function ($) {
  'use strict';

  var zoomImgOverlapX;
  var zoomImgOverlapY;
  var ratioX;
  var ratioY;
  var pointerPositionX;
  var pointerPositionY;
  var defaults = {
    // The text to display within the notice box while loading the zoom image.
    loadingNotice: 'Loading image',
    // The text to display within the notice box if an error occurs when loading the zoom image.
    errorNotice: 'The image could not be loaded',
    // The time (in milliseconds) to display the error notice.
    errorDuration: 2500,
    // Attribute to retrieve the zoom image URL from.
    linkAttribute: 'href',
    // Prevent clicks on the zoom image link.
    preventClicks: true,
    // Callback function to execute before the flyout is displayed.
    beforeShow: $.noop,
    // Callback function to execute before the flyout is removed.
    beforeHide: $.noop,
    // Callback function to execute when the flyout is displayed.
    onShow: $.noop,
    // Callback function to execute when the flyout is removed.
    onHide: $.noop,
    // Callback function to execute when the cursor is moved while over the image.
    onMove: $.noop
  };
  /**
   * EasyZoom
   * @constructor
   * @param {Object} target
   * @param {Object} options (Optional)
   */

  function EasyZoom(target, options) {
    this.$target = $(target);
    this.opts = $.extend({}, defaults, options, this.$target.data());
    this.isOpen === undefined && this._init();
  }
  /**
   * Init
   * @private
   */


  EasyZoom.prototype._init = function () {
    this.$link = this.$target.find('a');
    this.$image = this.$target.find('img');
    this.$flyout = $('<div class="easyzoom-flyout" />');
    this.$notice = $('<div class="easyzoom-notice" />');
    this.$target.on({
      'mousemove.easyzoom touchmove.easyzoom': $.proxy(this._onMove, this),
      'mouseleave.easyzoom touchend.easyzoom': $.proxy(this._onLeave, this),
      'click.easyzoom touchstart.easyzoom': $.proxy(this._onEnter, this)
    }); // this.opts.preventClicks && this.$target.on('click.easyzoom', function(e) {
    //     e.preventDefault();
    // });
  };
  /**
   * Show
   * @param {MouseEvent|TouchEvent} e
   * @param {Boolean} testMouseOver (Optional)
   */


  EasyZoom.prototype.show = function (e, testMouseOver) {
    var self = this;
    if (this.opts.beforeShow.call(this) === false) return;

    if (!this.isReady) {
      return this._loadImage(this.$link.attr(this.opts.linkAttribute), function () {
        if (self.isMouseOver || !testMouseOver) {
          self.show(e);
        }
      });
    } // Custom: add classes to PDP DOM elements 


    this.$target.closest('[data-product-images-slider]').addClass('is-image-zoomed');
    this.$target.closest('[data-product-image-zoomable]').addClass('is-image-zoomed'); // Custom: add class to body element

    $('body').addClass('is-image-zoomed');
    this.$target.append(this.$flyout);
    var targetWidth = this.$target.outerWidth();
    var targetHeight = this.$target.outerHeight();
    var flyoutInnerWidth = this.$flyout.width();
    var flyoutInnerHeight = this.$flyout.height();
    var zoomImgWidth = this.$zoom.width();
    var zoomImgHeight = this.$zoom.height();
    zoomImgOverlapX = Math.ceil(zoomImgWidth - flyoutInnerWidth);
    zoomImgOverlapY = Math.ceil(zoomImgHeight - flyoutInnerHeight); // For when the zoom image is smaller than the flyout element.

    if (zoomImgOverlapX < 0) zoomImgOverlapX = 0;
    if (zoomImgOverlapY < 0) zoomImgOverlapY = 0;
    ratioX = zoomImgOverlapX / targetWidth;
    ratioY = zoomImgOverlapY / targetHeight;
    this.isOpen = true;
    this.opts.onShow.call(this);
    e && this._move(e);
  };
  /**
   * On enter
   * @private
   * @param {Event} e
   */


  EasyZoom.prototype._onEnter = function (e) {
    //Didn't work due to desynchronization of click events
    //Prevent double action from being executed
    if (this._onEnterExec) {
      return;
    }
    //set up sync flag to true
    this._onEnterExec = true;
    //wait for everything setteles down
    setTimeout(() => {
      if ($('.easyzoom-flyout').length > 0) {
        e.preventDefault();
        this.isMouseOver = false;
        this.isOpen && this.hide();
      } else {
        var touches = e.originalEvent.touches;
        this.isMouseOver = true;
        if (!this.isOpen && (!touches || touches.length == 1)) {
          e.preventDefault();
          this.show(e, true);
          this.isOpen = true;
        }
      }
      //reset sync flag
      this._onEnterExec = false;
    }, 100);
  };
  /**
   * On move
   * @private
   * @param {Event} e
   */


  EasyZoom.prototype._onMove = function (e) {
    if (!this.isOpen) return;
    e.preventDefault();

    this._move(e);
  };
  /**
   * On leave
   * @private
   */


  EasyZoom.prototype._onLeave = function () {// CUSTOM: do nothing on leave
    // this.isMouseOver = false;
    // this.isOpen && this.hide();
  };
  /**
   * On load
   * @private
   * @param {Event} e
   */


  EasyZoom.prototype._onLoad = function (e) {
    // IE may fire a load event even on error so test the image dimensions
    if (!e.currentTarget.width) return;
    this.isReady = true;
    this.$notice.detach();
    this.$flyout.html(this.$zoom);
    this.$target.removeClass('is-loading').addClass('is-ready');
    e.data.call && e.data();
  };
  /**
   * On error
   * @private
   */


  EasyZoom.prototype._onError = function () {
    var self = this;
    this.$notice.text(this.opts.errorNotice);
    this.$target.removeClass('is-loading').addClass('is-error');
    this.detachNotice = setTimeout(function () {
      self.$notice.detach();
      self.detachNotice = null;
    }, this.opts.errorDuration);
  };
  /**
   * Load image
   * @private
   * @param {String} href
   * @param {Function} callback
   */


  EasyZoom.prototype._loadImage = function (href, callback) {
    var zoom = new Image();
    this.$target.addClass('is-loading').append(this.$notice.text(this.opts.loadingNotice));
    this.$zoom = $(zoom).on('error', $.proxy(this._onError, this)).on('load', callback, $.proxy(this._onLoad, this));
    zoom.style.position = 'absolute';
    zoom.src = href;
  };
  /**
   * Move
   * @private
   * @param {Event} e
   */


EasyZoom.prototype._move = function (e) {
    if (e.type.indexOf('touch') === 0) {
        var touchlist = e.touches || e.originalEvent.touches;
        pointerPositionX = touchlist[0].pageX;
        pointerPositionY = touchlist[0].pageY;
    } else {
        pointerPositionX = e.pageX || pointerPositionX;
        pointerPositionY = e.pageY || pointerPositionY;
    }

    var targetOffset = this.$target.offset();
    var relativePositionX = pointerPositionX - targetOffset.left;
    var relativePositionY = pointerPositionY - targetOffset.top;
    
    var zoomFactor = 1.6;
    var moveX = Math.ceil(relativePositionX * ratioX * zoomFactor);
    var moveY = Math.ceil(relativePositionY * ratioY * zoomFactor);

    var top = (moveY * -1) - 100;
    var left = moveX * -1;
    this.$zoom.css({
        top: top,
        left: left
    });
    this.opts.onMove.call(this, top, left);
};
  /**
   * Hide
   */


  EasyZoom.prototype.hide = function () {
    if (!this.isOpen) return;
    if (this.opts.beforeHide.call(this) === false) return; // Custom: remove classes from PDP DOM elements 

    this.$target.closest('[data-product-images-slider]').removeClass('is-image-zoomed');
    this.$target.closest('[data-product-image-zoomable]').removeClass('is-image-zoomed'); // Custom: remove class from body element

    $('body').removeClass('is-image-zoomed');
    this.$flyout.detach();
    this.isOpen = false;
    this.opts.onHide.call(this);
  };
  /**
   * Swap
   * @param {String} standardSrc
   * @param {String} zoomHref
   * @param {String|Array} srcset (Optional)
   */


  EasyZoom.prototype.swap = function (standardSrc, zoomHref, srcset) {
    this.hide();
    this.isReady = false;
    this.detachNotice && clearTimeout(this.detachNotice);
    this.$notice.parent().length && this.$notice.detach();
    this.$target.removeClass('is-loading is-ready is-error');
    this.$image.attr({
      src: standardSrc,
      srcset: $.isArray(srcset) ? srcset.join() : srcset
    });
    this.$link.attr(this.opts.linkAttribute, zoomHref);
  };
  /**
   * Teardown
   */


  EasyZoom.prototype.teardown = function () {
    this.hide();
    this.$target.off('.easyzoom').removeClass('is-loading is-ready is-error');
    this.detachNotice && clearTimeout(this.detachNotice);
    delete this.$link;
    delete this.$zoom;
    delete this.$image;
    delete this.$notice;
    delete this.$flyout;
    delete this.isOpen;
    delete this.isReady;
  }; // jQuery plugin wrapper


  $.fn.easyZoom = function (options) {
    return this.each(function () {
      var api = $.data(this, 'easyZoom');

      if (!api) {
        $.data(this, 'easyZoom', new EasyZoom(this, options));
      } else if (api.isOpen === undefined) {
        api._init();
      }
    });
  };

  return EasyZoom;
});
/**************************
pdp slider mobile vs desktop
**************************/
//const fraction = document.getElementById("fraction");
const slides = document.querySelectorAll(".swiper-slide");
//const slideCount = slides.length - 1;
//fraction.textContent = `1 / ${slideCount}`;
let windowWidth = window.innerWidth;
let swiperParams;
let swiper;

let breakpointParams = (width) => {
  if(width <= 1007){
      swiperParams = {
          on: {
                init: function () {
                    let videoSlide = document.getElementById('video-slide');
                    if (videoSlide){
                      videoSlide.style.opacity = '1';
                    }
                },
            },
          pagination: {
            el: ".swiper-pagination",
          },
          pagination: {
            el: ".swiper-pagination",
          },
          navigation: {
            nextEl: ".swiper-next-btn",
            prevEl: ".swiper-prev-btn",
          },
          effect: "creative",
          creativeEffect: {
            prev: {
              translate: [-10, 0, 0]
            },
            next: {
              translate: [10, 0, 0]
            }
          },
          zoom: {
            enabled: false,
            panOnMouseMove: true
          },
          followFinger: false,
          /*
          on: {
              slideChange: () => {
                  fraction.textContent = `${swiper.realIndex + 1} / ${slideCount}`;
              },
          }
          */
        };

        if (typeof swiper === 'object') {
          swiper.destroy();
        }
        swiper = new Swiper('.pdp-swiper', swiperParams);

  }else if (width > 1008){
      swiperParams = {
          on: {
                init: function () {
                    let videoSlide = document.getElementById('video-slide');
                    if (videoSlide){
                      videoSlide.style.opacity = '1';
                    }
                },
            },
          pagination: {
            el: ".swiper-pagination",
          },
          navigation: {
            nextEl: ".swiper-next-btn",
            prevEl: ".swiper-prev-btn",
          },
          mousewheel: {
            enabled: true,
            releaseOnEdges: true
          },
          zoom: {
            enabled: false,
            panOnMouseMove: true
          },
          slidesPerView: 2,
          /*
          on: {
              slideChange: () => {
                  fraction.textContent = `${swiper.realIndex + 1} / ${slideCount}`;
              },
          }
          */
      };

      if (typeof swiper === 'object') {
      	swiper.destroy();
      }

      swiper = new Swiper('.pdp-swiper', swiperParams);
/*
$(document).ready(function() {

    var easyzoom = $('.easyzoom').easyZoom();

    $(document).on('click', '.easyzoom', function() {
        easyzoom.show();
    });
    $(document).on('click', '.is-image-zoomed', function() {
        easyzoom.hide();
    });
});
*/

    document.addEventListener('DOMContentLoaded', function () {
      //DEBUG: override stopPropagation and preventDefault to check what's up
      // const _oldPropagation = Event.prototype.stopPropagation;
      // const _oldPreventDefault = Event.prototype.preventDefault;
      // Event.prototype.stopPropagation = function () {
      //   if (this.type != 'click') {
      //     _oldPropagation.call(this);
      //     return;
      //   }
      //   console.trace();
      //   console.log('Overriden stop propagarion', this);
      // };
      // Event.prototype.preventDefault = function () {
      //   if (this.type != 'click') {
      //     _oldPreventDefault.call(this);
      //     return;
      //   }
      //   console.trace();
      //   console.log('Overriden preventDefault', this);
      // };

      //set timeout to postpone EasyZoom action binding
      setTimeout(() => {
        //console.log('Initializing easyzoom');
        //jQuery new EasyZoom();
        var easyzoom = $('.easyzoom').easyZoom();
        //DEBUG, don't need this anymore 
        //var api = easyzoom.data('easyZoom');
        // if (!easyzoom.data('action-bound') && api) {
        //   easyzoom.data('action-bound', true);
        //   var container = document.querySelector('.easyzoom');
        //   console.log(container)
        //   container.addEventListener('click', function (e) {
        //     console.log('Clicked', 'api', api.isOpen);
        //     //e.preventDefault();
        //     if (!api.isOpen) {
        //       api.show();
        //     } else {
        //       api.hide();
        //     }
        //   });
        // }
      }, 100);
    });
  }
};


function handleResize() {
  windowWidth = window.innerWidth;
  breakpointParams(windowWidth);
}

const resizeObserver = new ResizeObserver(handleResize);
resizeObserver.observe(document.body);
handleResize();
/**************************
color-text changer
**************************/
/*
let variantsList = document.querySelectorAll('.item-product-variants-wrap > ul > li');
const currentVariantColor = document.querySelector('[container-color-name=""]').innerText;
let colorNameContainer = document.querySelector('[container-color-name=""]');

variantsList.forEach((item) => {
  item.addEventListener("mouseover", (e) => {
    let itemColorName = item.dataset.colorVariantName;
    colorNameContainer.innerText = itemColorName;
  });
  item.addEventListener("mouseout", (e) => {
    colorNameContainer.innerText = currentVariantColor;
  });
})
*/
/**************************
size guide
**************************/
const sizeGuideButton = document.querySelector('.size-guide-btn');
const modalOverlay = document.querySelector('#size-guide-overlay');

if (sizeGuideButton) {
  sizeGuideButton.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    modalOverlay.style.display = 'flex';
    setTimeout(function() {
      modalOverlay.style.opacity = '1';
    }, 100);
  });
}


modalOverlay.addEventListener("click", (e) => {
  e.preventDefault();
  e.stopPropagation();
  modalOverlay.style.opacity = '0';
  setTimeout(function() {
    modalOverlay.style.display = 'none';
  }, 400);
});
/**************************
find in store
**************************/

const fisButton = document.querySelector('#fis-button');
const modalFisOverlay = document.querySelector('#fis-overlay');
const modalFisWrapper = document.querySelector('#fis-main-wrapper');
const modalFisCloseBtn = document.querySelector('.fis-close');
const fisBody = document.querySelector('.fis-body');

function showOverlay() {
  modalFisOverlay.style.display = 'flex';
  setTimeout(() => {
    modalFisOverlay.style.opacity = '1';
  }, 100);
}

function hideOverlay() {
  modalFisOverlay.style.opacity = '0';
  setTimeout(() => {
    modalFisOverlay.style.display = 'none';
  }, 400);
}

if(fisButton){
fisButton.addEventListener("click", (e) => {
  e.preventDefault();
  showOverlay();
});
}


if(modalFisWrapper){
modalFisWrapper.addEventListener("click", (e) => {
  if (!fisBody.contains(e.target)) {
    hideOverlay();
  }
});
}


modalFisCloseBtn.addEventListener("click", (e) => {
    hideOverlay();
});
/**************************
hide other varians images
**************************/
const mainImageContainer = document.querySelector('.main-product-images');
const productImagesAll = Array.from(mainImageContainer.children);
const urlVariantId = new URLSearchParams(window.location.search).get('variant');
const bodyHasClass = document.body.classList.contains('template-product-pdp-accordion-old');
//if not old template
if(!bodyHasClass){
  productImagesAll.forEach((item) => {
      if (!item.classList.contains('video-slide-wrapper') && !item.dataset.variantId.includes(urlVariantId)) {
        item.classList.add('hidden');
      }
  });
}
/**************************
pagination bullets
**************************/
const updatePaginationStyles = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 1007) {
    const paginationBullets = document.querySelectorAll('.swiper-pagination-bullet');
    const bulletWidth = screenWidth / paginationBullets.length / 1.3;

    paginationBullets.forEach((item) => {
      item.style.marginLeft = '3px';
      item.style.marginRight = '0';
      item.style.width = bulletWidth + 'px';
    });
  }
};

document.addEventListener("DOMContentLoaded", updatePaginationStyles);
window.addEventListener("resize", updatePaginationStyles);
/**************************
mobile-size-popover
show-size
**************************/
let showSizeBtnScroll = document.querySelector('#atc-button');
let mobileSizePopover = document.querySelector('.mobile-size-popover');
let viewportHeightTwo = window.innerHeight;
//console.log(showSizeBtnScroll.getAttribute('aria-expanded'));
const observerSize = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.attributeName === 'aria-hidden') {

        if(mobileSizePopover.getAttribute('aria-hidden') == 'false'){
          
        const blockPositionTwo = showSizeBtnScroll.getBoundingClientRect().top + window.pageYOffset - viewportHeightTwo + 43;

        const topOffset = blockPositionTwo;
        window.scrollTo({
            top: topOffset,
            behavior: 'smooth'
        });

        }
    }

  });
});

const config = { attributes: true, attributeFilter: ['aria-hidden'] };
if (sizeGuideButton) {
  observerSize.observe(mobileSizePopover, config);
}